module.exports = __webpack_public_path__ + "static/media/logo-less-shadow.6387b5e0.png";